import React from 'react'

const STORAGE_KEY = 'plannr-handover-printer-settings'

export interface PrinterSettings {
  /** Automatically print a handover label on every successful scan */
  autoPrintEnabled: boolean
  /** uid of the selected Browser Print device; null = use the agent's default printer */
  printerUid: string | null
}

const DEFAULT_SETTINGS: PrinterSettings = {
  autoPrintEnabled: false,
  printerUid: null,
}

export const readPrinterSettings = (): PrinterSettings => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY)
    if (!raw) {
      return DEFAULT_SETTINGS
    }
    return { ...DEFAULT_SETTINGS, ...JSON.parse(raw) }
  } catch (error) {
    return DEFAULT_SETTINGS
  }
}

/**
 * Per-station printer settings, persisted in localStorage: printing is a
 * property of the physical workstation (laptop + USB printer), not of the
 * subco account.
 */
export const usePrinterSettings = (): [
  PrinterSettings,
  (changes: Partial<PrinterSettings>) => void,
] => {
  const [settings, setSettings] =
    React.useState<PrinterSettings>(readPrinterSettings)

  const updateSettings = React.useCallback(
    (changes: Partial<PrinterSettings>) => {
      setSettings((prev) => {
        const next = { ...prev, ...changes }
        try {
          window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next))
        } catch (error) {
          // storage full/blocked: settings still work for this session
        }
        return next
      })
    },
    [],
  )

  return [settings, updateSettings]
}
